import { render, staticRenderFns } from "./TaskMentionChangedActivity.vue?vue&type=template&id=17e17bb6"
import script from "./TaskMentionChangedActivity.vue?vue&type=script&lang=js"
export * from "./TaskMentionChangedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports